import React, { useState, useEffect, useRef, useCallback } from "react";
import _ from 'i18n';
import { connect } from "react-redux";
import EventLineChart from "./EventLineChart";
import EventLineChartLegend from "./EventLineChartLegend";
import EventLineChartDetails from "./EventLineChartDetails";
import EventLineChartFilters from "./EventLineChartFilters";
import {
  fetchRegistrantLineChartCAData,
  fetchRegistrantLineChartData,
  getSeasonsValues
} from "../../../../actions/thunks/eventStats";
import EventLineChartErrorHandler from "./EventLineChartErrorHandler";
import moment from "moment";
import { showErrorNotification } from "../../../../services/utils";
import CompareStats from "./CompareStats/CompareStats";
import axios from "axios";
import BudgetManagementModal from "../BudgetManagement/BudgetManagementModal";
import EventLineChartLegendFormat from "./EventLineChartLegendFormat";
import { getAccumulateEventStats, getActivePremium, getCommandInfo, startCommandCumulateByFormat, startCommandGetCANbrInscriptionByFormat } from "../../../../actions/thunks/statistics";
import { getParticipantsStatsAction } from "../../../../actions/thunks/eventStats";
import EventLineChartFormat from "./EventLineChartFormat";
import { CommonLoader } from "../../../common/CommonLoader";
import CompareStatsChart from "./CompareStats/CompareStatsChart";
import { SyncOutlined } from "@ant-design/icons";

const getRandomColor = () => {
  const letters = '0123456789ABCDEF';
  let color = '#';
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
};

const getInitialChartLinesToShow = (businessType) => {
  if (businessType === 'SUPER_CHAIN') {
    return ['formations', 'cycles', 'cycles_essential', 'saisons', 'monthly_premium', 'yearly_premium', 'congrès'];
  } else if (businessType === 'MASTER_CHAIN') {
    return ['formations', 'cycles'];
  }
  return ['formations'];
};

const getInitialShowCompareAppTypeStatsArray = (businessType) => {
  const arr = [];
  if (businessType === 'SUPER_CHAIN') {
    arr['formations'] = false;
    arr['cycles'] = false;
    arr['cycles_essential'] = false;
    arr['saisons'] = false;
    arr['monthly_premium'] = false;
    arr['yearly_premium'] = false;
    arr['congrès'] = false;
  } else if (businessType === 'MASTER_CHAIN') {
    arr['formations'] = false;
    arr['cycles'] = false;
  } else {
    arr['formations'] = false;
  }
  return arr;
};

const EventRegistrantLineChart = ({
  auth,
  eventStatsFilter,
  language,
  fetchRegistrantLineChartData,
  fetchRegistrantLineChartCAData,
  getSeasonsValues,
  startCommandGetCANbrInscriptionByFormat,
  getCommandInfo,
  getActivePremium,
  getAccumulateEventStats,
  startCommandCumulateByFormat,
  getParticipantsStatsAction,
}) => {
  const businessType = auth.currentClient.businessType;

  // ─── State ────────────────────────────────────────────────────────────────────

  const [chartLinesToShow, setChartLinesToShow] = useState(() => getInitialChartLinesToShow(businessType));
  const [chartLinesToShowFormat, setChartLinesToShowFormat] = useState([]);
  const [formatData, setFormatData] = useState([]);
  const [formatCAData, setFormatCAData] = useState([]);
  const [isFormatFetching, setIsFormatFetching] = useState(false);
  const [isFormatError, setIsFormatError] = useState(false);
  const [fetching, setFetching] = useState(true);
  const [data, setData] = useState([]);
  const [isError, setIsError] = useState(false);
  const [CAfetching, setCAfetching] = useState(true);
  const [CAdata, setCAdata] = useState([]);
  const [dataPrevYear, setDataPrevYear] = useState([]);
  const [dataPrevYearFetching, setDataPrevYearFetching] = useState(true);
  const [CAdataPrevYear, setCAdataPrevYear] = useState([]);
  const [CAdataPrevYearFetching, setCAdataPrevYearFetching] = useState(true);
  const [CAisError, setCAisError] = useState(false);
  const [frequency, setFrequency] = useState('MONTHLY');
  const [period, setPeriod] = useState(eventStatsFilter.year);
  const [languages, setLanguages] = useState(['FR', 'NL', 'EN']);
  const [showCompareStats, setShowCompareStats] = useState(false);
  const [chartType, setChartType] = useState('REGISTRATION');
  const [legendType, setLegendType] = useState('TYPE');
  const [isBudgetManagementModalVisible, setIsBudgetManagementModalVisible] = useState(false);
  const [legendIsFetching, setLegendIsFetching] = useState(false);
  const [showSpinner, setShowSpinner] = useState(false);
  const [seasonsToShow, setSeasonsToShow] = useState([]);
  const [chartLinesToShowSeason, setChartLinesToShowSeason] = useState([]);
  const [showCompareAppTypeStats, setShowCompareAppTypeStats] = useState(false);
  const [showCompareAppTypeStatsArray, setShowCompareAppTypeStatsArray] = useState(() => getInitialShowCompareAppTypeStatsArray(businessType));
  const [lineNameForStats, setLineNameForStats] = useState('');
  const [compareAll, setCompareAll] = useState(false);
  const [activePremium, setActivePremium] = useState({});
  const [accumulateEventStats, setAccumulateEventStats] = useState([]);
  const [accumulateEventStatsCA, setAccumulateEventStatsCA] = useState([]);
  const [accumulateEventStatsFetching, setAccumulateEventStatsFetching] = useState(false);
  const [accumulateEventStatsCAFetching, setAccumulateEventStatsCAFetching] = useState(false);
  const [accumulateEventStatsPrevYear, setAccumulateEventStatsPrevYear] = useState([]);
  const [accumulateEventStatsCAPrevYear, setAccumulateEventStatsCAPrevYear] = useState([]);
  const [accumulateEventStatsPrevYearFetching, setAccumulateEventStatsPrevYearFetching] = useState(false);
  const [accumulateEventStatsCAPrevYearFetching, setAccumulateEventStatsCAPrevYearFetching] = useState(false);
  const [showAccumulateEventStats, setShowAccumulateEventStats] = useState(false);
  const [formatAccumulateData, setFormatAccumulateData] = useState([]);
  const [formatAccumulateCAData, setFormatAccumulateCAData] = useState([]);
  const [isDownloadParticipantsStatsLoading, setIsDownloadParticipantsStatsLoading] = useState(false);

  // Refs for timers and request IDs (replacing class instance variables)
  const commandTimerRef = useRef(null);
  const currRequestIdRef = useRef(null);
  const isFirstRender = useRef(true);
  const prevEventStatsFilterYear = useRef(eventStatsFilter.year);

  // ─── Handlers ────────────────────────────────────────────────────────────────

  const hideChartLine = useCallback((line) => {
    setChartLinesToShow(prev => prev.filter(chartLine => chartLine !== line));
  }, []);

  const showChartLine = useCallback((line) => {
    setChartLinesToShow(prev => [...prev, line]);
  }, []);

  const hideChartLineFormat = useCallback((line) => {
    setChartLinesToShowFormat(prev => prev.filter(chartLine => chartLine !== line));
  }, []);

  const showChartLineFormat = useCallback((line) => {
    setChartLinesToShowFormat(prev => [...prev, line]);
  }, []);

  const hideChartLineFormatSeason = useCallback((line) => {
    setChartLinesToShowSeason(prev => prev.filter(chartLine => chartLine.lineName !== line));
  }, []);

  const showChartLineFormatSeason = useCallback((line) => {
    const generatedColor = getRandomColor();
    setChartLinesToShowSeason(prev => [...prev, { legend: line, color: generatedColor, lineName: line }]);
    setSeasonsToShow(prev => prev.map(season =>
      season.legend === line ? { ...season, color: generatedColor } : season
    ));
  }, []);

  const updateChartLinesToShow = useCallback((line) => {
    setChartLinesToShow(prev => {
      const found = prev.find(element => element === line);
      if (found) {
        return prev.filter(chartLine => chartLine !== line);
      }
      return [...prev, line];
    });
  }, []);

  const updateChartLinesToShowFormat = useCallback((line) => {
    setChartLinesToShowFormat(prev => {
      const found = prev.find(element => element === line);
      if (found) {
        hideChartLineFormat(line);
        hideChartLineFormatSeason(line);
        return prev.filter(chartLine => chartLine !== line);
      }
      showChartLineFormat(line);
      showChartLineFormatSeason(line);
      return [...prev, line];
    });
  }, [hideChartLineFormat, hideChartLineFormatSeason, showChartLineFormat, showChartLineFormatSeason]);

  const updateFrequency = useCallback((newFrequency) => {
    let newPeriod = [];
    if (newFrequency === "MONTHLY") {
      newPeriod = eventStatsFilter.year;
    } else if (newFrequency === "DAILY") {
      const currentMonth = moment().month() + 1;
      const currentMonthFormatted =
        eventStatsFilter.year[0] + '-' + (currentMonth >= 10 ? currentMonth : '0' + currentMonth);
      newPeriod = [currentMonthFormatted];
    }
    setFrequency(newFrequency);
    setPeriod(newPeriod);
    setShowCompareStats(false);
    setShowAccumulateEventStats(false);
  }, [eventStatsFilter.year]);

  const updateChartType = useCallback((newChartType) => {
    setChartType(newChartType);
  }, []);

  const updateLegendType = useCallback((newLegendType) => {
    setLegendType(newLegendType);
    setShowAccumulateEventStats(false);
    setShowCompareStats(false);
  }, []);

  const updatePeriod = useCallback((newPeriod) => {
    setPeriod(newPeriod);
    setShowAccumulateEventStats(false);
    setShowCompareStats(false);
  }, []);

  const updateLanguages = useCallback((lang) => {
    setLanguages(prev => {
      if (!prev.includes(lang)) {
        return [...prev, lang];
      } else if (prev.length > 1) {
        return prev.filter(l => l !== lang);
      }
      return prev;
    });
    setShowCompareStats(false);
  }, []);

  const handleShowCompareStats = useCallback((value) => {
    setShowCompareStats(value);
  }, []);

  const handleBudgetManagementModalVisibility = useCallback((value) => {
    setIsBudgetManagementModalVisible(value);
  }, []);

  const handleShowAccumulateEventStats = useCallback((event) => {
    setShowAccumulateEventStats(event.target.checked);
  }, []);

  const showCompareStatsForAppType = useCallback((lineName) => {
    if (lineName === lineNameForStats) {
      setShowCompareAppTypeStatsArray(prev =>
        Object.keys(prev).reduce((acc, key) => { acc[key] = false; return acc; }, {})
      );
      setShowCompareAppTypeStats(false);
      setLineNameForStats('');
      return;
    }
    setShowCompareAppTypeStatsArray(prev =>
      Object.keys(prev).reduce((acc, key) => { acc[key] = key === lineName; return acc; }, {})
    );
    setShowCompareAppTypeStats(true);
    setLineNameForStats(lineName);
    setCompareAll(false);
  }, [lineNameForStats]);

  const showCompareStatsForAllAppType = useCallback((currentCompareAll) => {
    setShowCompareAppTypeStatsArray(prev =>
      Object.keys(prev).reduce((acc, key) => { acc[key] = false; return acc; }, {})
    );
    setShowCompareAppTypeStats(!currentCompareAll);
    setLineNameForStats('');
    setCompareAll(!currentCompareAll);
  }, []);

  const handleCancelDailyCompareAppType = useCallback(() => {
    setShowCompareAppTypeStatsArray(prev =>
      Object.keys(prev).reduce((acc, key) => { acc[key] = false; return acc; }, {})
    );
    setShowCompareAppTypeStats(false);
    setLineNameForStats('');
  }, []);

  // ─── Data Fetching ────────────────────────────────────────────────────────────

  const getSeasons = useCallback(() => {
    const params = {};
    if (auth.currentClient) {
      params.issuerId = auth.currentClient.id;
    }
    getSeasonsValues(params);
  }, [auth.currentClient, getSeasonsValues]);

  const fetchRegistrantLineChartDataOnly = useCallback(() => {
    setLegendIsFetching(true);
    fetchRegistrantLineChartData(frequency, period, languages).then((res) => {
      setData(res.data.data);
      setLegendIsFetching(false);
    }).catch((err) => {
      if (!axios.isCancel(err)) {
        setIsError(true);
        setData([]);
        showErrorNotification(_('error'), _('errorOccured'));
      }
    });
  }, [fetchRegistrantLineChartData, frequency, period, languages]);

  const fetchRegistrantLineChartCADataOnly = useCallback(() => {
    setCAfetching(true);
    setCAisError(false);
    fetchRegistrantLineChartCAData(frequency, period, languages).then((res) => {
      setCAfetching(false);
      setCAdata(res.data.data);
    }).catch((err) => {
      if (!axios.isCancel(err)) {
        setCAfetching(false);
        setCAisError(true);
        setCAdata([]);
        showErrorNotification(_('error'), _('errorOccured'));
      }
    });
  }, [fetchRegistrantLineChartCAData, frequency, period, languages]);

  const fetchRegistrantLineChartAllData = useCallback(() => {
    setFetching(true);
    setCAfetching(true);
    setIsError(false);
    setDataPrevYearFetching(true);
    setCAdataPrevYearFetching(true);

    let previousYearDate = '';

    if (frequency === 'DAILY') {
      const [, monthDate] = period[0].split("-");
      previousYearDate = `${eventStatsFilter.year - 1}-${monthDate}`;
    }

    fetchRegistrantLineChartData(frequency, period, languages).then((res) => {
      setFetching(false);
      setData(res.data.data);

      fetchRegistrantLineChartCAData(frequency, period, languages).then((res) => {
        setCAfetching(false);
        setCAdata(res.data.data);

        if (frequency === 'DAILY') {
          fetchRegistrantLineChartData(frequency, [previousYearDate], languages, 0, 1).then((res) => {
            setFetching(false);
            setDataPrevYear(res.data.data);
            setDataPrevYearFetching(false);

            fetchRegistrantLineChartCAData(frequency, [previousYearDate], languages, 0, 1).then((res) => {
              setCAfetching(false);
              setCAdataPrevYear(res.data.data);
              setCAdataPrevYearFetching(false);
            }).catch((err) => {
              if (!axios.isCancel(err)) {
                setCAfetching(false);
                setCAisError(true);
                setCAdataPrevYear([]);
                showErrorNotification(_('error'), _('errorOccured'));
              }
            });
          }).catch((err) => {
            if (!axios.isCancel(err)) {
              setFetching(false);
              setIsError(true);
              setDataPrevYear([]);
              showErrorNotification(_('error'), _('errorOccured'));
            }
          });
        }
      }).catch((err) => {
        if (!axios.isCancel(err)) {
          setCAfetching(false);
          setCAisError(true);
          setCAdata([]);
          showErrorNotification(_('error'), _('errorOccured'));
        }
      });
    }).catch((err) => {
      if (!axios.isCancel(err)) {
        setFetching(false);
        setIsError(true);
        setData([]);
        showErrorNotification(_('error'), _('errorOccured'));
      }
    });

    if (frequency === 'MONTHLY') {
      getActivePremium(period, frequency, '01', '12').then((res) => {
        setActivePremium(res.value.data.data);
      });
    }

    if (frequency === 'DAILY') {
      const [, monthDate] = period[0].split("-");
      const prevYearDate = `${eventStatsFilter.year - 1}-${monthDate}`;

      setAccumulateEventStatsFetching(true);
      setAccumulateEventStatsCAFetching(true);
      setAccumulateEventStatsPrevYearFetching(true);
      setAccumulateEventStatsCAPrevYearFetching(true);

      getAccumulateEventStats(frequency, period, languages, 'NBR').then((res) => {
        setAccumulateEventStats(res.value.data.data);
        setAccumulateEventStatsFetching(false);
      });
      getAccumulateEventStats(frequency, period, languages, 'CA').then((res) => {
        setAccumulateEventStatsCA(res.value.data.data);
        setAccumulateEventStatsCAFetching(false);
      });
      getAccumulateEventStats(frequency, [prevYearDate], languages, 'NBR').then((res) => {
        setAccumulateEventStatsPrevYear(res.value.data.data);
        setAccumulateEventStatsPrevYearFetching(false);
      });
      getAccumulateEventStats(frequency, [prevYearDate], languages, 'CA').then((res) => {
        setAccumulateEventStatsCAPrevYear(res.value.data.data);
        setAccumulateEventStatsCAPrevYearFetching(false);
      });
    }
  }, [
    frequency, period, languages, eventStatsFilter.year,
    fetchRegistrantLineChartData, fetchRegistrantLineChartCAData,
    getActivePremium, getAccumulateEventStats,
  ]);

  const getCANbrInscriptionByFormat = useCallback(() => {
    setShowSpinner(true);
    setIsFormatFetching(true);
    setIsFormatError(false);

    if (!showAccumulateEventStats) {
      startCommandGetCANbrInscriptionByFormat(frequency, period, languages).then((res) => {
        clearInterval(commandTimerRef.current);

        const startCommandTimer = () => {
          currRequestIdRef.current = `COMMAND_REQUEST_${performance.now()}`;
          const prevRequestId = currRequestIdRef.current;

          getCommandInfo(res.value.data.data.command.id).then((resultat) => {
            if (prevRequestId !== currRequestIdRef.current) return;
            if (resultat.data.data.status !== "FINISHED") {
              setShowSpinner(true);
              setIsFormatFetching(true);
              return;
            }

            const newSeasons = resultat.data.data.result.seasons.map(name => ({
              legend: name, color: getRandomColor(), lineName: name,
            }));
            const newSeasonsNames = resultat.data.data.result.seasons.map(name => name);

            setFormatData(resultat.data.data.result.nbrInscrits);
            setFormatCAData(resultat.data.data.result.caffaire);
            setSeasonsToShow(newSeasons);
            setChartLinesToShowSeason(newSeasons);
            setChartLinesToShowFormat(newSeasonsNames);
            setShowSpinner(false);
            setIsFormatFetching(false);
            clearInterval(commandTimerRef.current);
          }).catch(() => {
            clearInterval(commandTimerRef.current);
          });
        };

        commandTimerRef.current = setInterval(startCommandTimer, 3 * 1000);
      });
    }

    if (frequency === 'DAILY' && showAccumulateEventStats) {
      startCommandCumulateByFormat(frequency, period, languages, 'NBR').then((res) => {
        clearInterval(commandTimerRef.current);

        const startCommandTimer = () => {
          currRequestIdRef.current = `COMMAND_REQUEST_${performance.now()}`;
          const prevRequestId = currRequestIdRef.current;

          getCommandInfo(res.value.data.data.command.id).then((resultat) => {
            if (prevRequestId !== currRequestIdRef.current) return;
            if (resultat.data.data.status !== "FINISHED") {
              setShowSpinner(true);
              setIsFormatFetching(true);
              return;
            }

            setFormatAccumulateData(resultat.data.data.result);
            clearInterval(commandTimerRef.current);

            startCommandCumulateByFormat(frequency, period, languages, 'CA').then((res) => {
              clearInterval(commandTimerRef.current);

              const startInnerTimer = () => {
                currRequestIdRef.current = `COMMAND_REQUEST_${performance.now()}`;
                const prevInnerRequestId = currRequestIdRef.current;

                getCommandInfo(res.value.data.data.command.id).then((resultat) => {
                  if (prevInnerRequestId !== currRequestIdRef.current) return;
                  if (resultat.data.data.status !== "FINISHED") {
                    setShowSpinner(true);
                    setIsFormatFetching(true);
                    return;
                  }
                  setFormatAccumulateCAData(resultat.data.data.result);
                  setShowSpinner(false);
                  setIsFormatFetching(false);
                  clearInterval(commandTimerRef.current);
                }).catch(() => {
                  clearInterval(commandTimerRef.current);
                });
              };

              commandTimerRef.current = setInterval(startInnerTimer, 3 * 1000);
            });
          }).catch(() => {
            clearInterval(commandTimerRef.current);
          });
        };

        commandTimerRef.current = setInterval(startCommandTimer, 3 * 1000);
      });
    }
  }, [
    frequency, period, languages, showAccumulateEventStats,
    startCommandGetCANbrInscriptionByFormat, startCommandCumulateByFormat, getCommandInfo,
  ]);

  const handleGetParticipantsStatsAction = useCallback(() => {
    setIsDownloadParticipantsStatsLoading(true);
    getParticipantsStatsAction().then((res) => {
      const data = res.value.data.data;

      const allYears = new Set();
      data.forEach(participant => {
        if (participant.years) {
          Object.keys(participant.years).forEach(year => allYears.add(year));
        }
      });
      const sortedYears = Array.from(allYears).sort((a, b) => a - b);

      const baseHeaders = [
        'ID', 'Prénom', 'Nom', 'Email', 'Téléphone', 'Numéro ITAA',
        'Langue', 'L\'âge', 'Province', 'Total Heures Suivies', 'Total Budget Dépensé',
      ];

      const yearHeaders = [];
      sortedYears.forEach(year => {
        yearHeaders.push(
          `${year} Heures Suivies`,
          `${year} Événements uniques suivis`,
          `${year} Événements Cycle Suivis`,
          `${year} Cycles Suivis`,
          `${year} Événements Essentials Suivis`,
          `${year} Essentials Suivis`,
          `${year} Événements Saisons Suivis`,
          `${year} Saisons Suivies`,
          `${year} Événements Premium Suivis`,
          `${year} Premiums Suivis`,
          `${year} Budget Dépensé`,
        );
      });

      const headers = [...baseHeaders, ...yearHeaders];
      const csvRows = [headers.join(';')];

      data.forEach(participant => {
        const baseRow = [
          participant.userId || '',
          participant.firstName || '',
          participant.lastName || '',
          participant.email || '',
          participant.phone || '',
          participant.itaaNumber || '',
          participant.language || '',
          participant.birthday
            ? moment().diff(moment(participant.birthday, 'YYYY-MM-DD'), 'years')
            : '',
          participant.province || '',
          participant.totalHoursFollowed || '0',
          participant.totalBudgetSpent || '0.00',
        ];

        const yearData = [];
        sortedYears.forEach(year => {
          const yearStats = participant.years && participant.years[year];
          if (yearStats) {
            yearData.push(
              yearStats.hoursFollowed || '0',
              yearStats.uniqueEventsFollowed || '0',
              yearStats.cycleEventsFollowed || '0',
              yearStats.cyclesFollowed || '0',
              yearStats.essentialEventsFollowed || '0',
              yearStats.essentialsFollowed || '0',
              yearStats.seasonEventsFollowed || '0',
              yearStats.seasonsFollowed || '0',
              yearStats.premiumEventsFollowed || '0',
              yearStats.premiumsFollowed || '0',
              yearStats.budgetSpent || '0.00',
            );
          } else {
            yearData.push('0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0.00');
          }
        });

        csvRows.push([...baseRow, ...yearData].join(';'));
      });

      const csvContent = '\uFEFF' + csvRows.join('\n');
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);
      const date = new Date().toISOString().split('T')[0];

      link.setAttribute('href', url);
      link.setAttribute('download', `participants_stats_${date}.csv`);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setIsDownloadParticipantsStatsLoading(false);
    }).catch((error) => {
      console.error('Error fetching participants stats:', error);
      setIsDownloadParticipantsStatsLoading(false);
    });
  }, [getParticipantsStatsAction]);

  // ─── Lifecycle Effects ────────────────────────────────────────────────────────

  // componentDidMount
  useEffect(() => {
    fetchRegistrantLineChartAllData();
    getSeasons();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Cleanup timer on unmount
  useEffect(() => {
    return () => clearInterval(commandTimerRef.current);
  }, []);

  // componentDidUpdate: re-fetch when frequency, period, languages, legendType or showAccumulateEventStats change
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    if (legendType === 'TYPE') {
      fetchRegistrantLineChartAllData();
    } else {
      getCANbrInscriptionByFormat();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [frequency, period, languages, legendType, showAccumulateEventStats]);

  // componentDidUpdate: react to eventStatsFilter.year changes
  useEffect(() => {
    if (prevEventStatsFilterYear.current === eventStatsFilter.year) return;
    prevEventStatsFilterYear.current = eventStatsFilter.year;

    if (eventStatsFilter.year.length === 0) {
      setFrequency('YEARLY');
      setPeriod([]);
      setShowCompareStats(false);
    } else if (eventStatsFilter.year.length === 1) {
      setFrequency('MONTHLY');
      setPeriod(eventStatsFilter.year);
      setShowCompareStats(false);
    }

    getSeasons();
  }, [eventStatsFilter.year, getSeasons]);

  // ─── Derived values ───────────────────────────────────────────────────────────

  const chartData    = data;
  const chartDataCA  = CAdata;
  const isFetching   = fetching || CAfetching;
  const error        = CAisError || isError;

  const chartDataByLinename = lineNameForStats
    ? data.map(item => ({ name: item.name, [lineNameForStats]: item[lineNameForStats] }))
    : data;

  const chartDataByLinenameAccumulate = lineNameForStats
    ? accumulateEventStats.map(item => ({ name: item.name, [lineNameForStats]: item[lineNameForStats] }))
    : accumulateEventStats;

  const chartDataCAByLinename = lineNameForStats
    ? CAdata.map(item => ({ name: item.name, [lineNameForStats]: item[lineNameForStats] }))
    : CAdata;

  const chartDataCAByLinenamAccumulate = lineNameForStats
    ? accumulateEventStatsCA.map(item => ({ name: item.name, [lineNameForStats]: item[lineNameForStats] }))
    : accumulateEventStatsCA;

  const chartDataByLinenamePrevYear = lineNameForStats
    ? dataPrevYear.map(item => ({ name: item.name, [lineNameForStats]: item[lineNameForStats] }))
    : dataPrevYear;

  const chartDataByLinenamePrevYearAccumulate = lineNameForStats
    ? accumulateEventStatsPrevYear.map(item => ({ name: item.name, [lineNameForStats]: item[lineNameForStats] }))
    : accumulateEventStatsPrevYear;

  const chartDataCAByLinenamePrevYear = lineNameForStats
    ? CAdataPrevYear.map(item => ({ name: item.name, [lineNameForStats]: item[lineNameForStats] }))
    : CAdataPrevYear;

  const chartDataCAByLinenamePrevYearAccumulate = lineNameForStats
    ? accumulateEventStatsCAPrevYear.map(item => ({ name: item.name, [lineNameForStats]: item[lineNameForStats] }))
    : accumulateEventStatsCAPrevYear;

  // ─── Render ───────────────────────────────────────────────────────────────────

  return (
    <div className={"event-registrant-line-chart"} style={{ position: 'relative', zIndex: 99 }}>

      <EventLineChartFilters
        updateFrequency={updateFrequency}
        frequency={frequency}
        updatePeriod={updatePeriod}
        period={period}
        language={language}
        languages={languages}
        type={chartType}
        legendType={legendType}
        updateLanguages={updateLanguages}
        updateChartType={updateChartType}
        updateLegendType={updateLegendType}
        eventStatsFilter={eventStatsFilter}
        showAccumulateEventStats={showAccumulateEventStats}
        handleShowAccumulateEventStats={handleShowAccumulateEventStats}
        fetching={isFetching || accumulateEventStatsFetching || accumulateEventStatsCAFetching || accumulateEventStatsPrevYearFetching || accumulateEventStatsCAPrevYearFetching}
      />

      <div className="event-registrant-line-chart-body">
        <div className="event-registrant-line-chart-body-aside">
          {
            legendType === 'TYPE' ?
              <EventLineChartLegend
                updateChartLinesToShow={updateChartLinesToShow}
                chartLinesToShow={chartLinesToShow}
                chartData={chartData}
                chartDataCA={chartDataCA}
                fetching={isFetching}
                isError={error}
                type={chartType}
                frequency={frequency}
                showCompareAppTypeStats={showCompareAppTypeStats}
                showCompareStatsForAppType={showCompareStatsForAppType}
                dataPrevYearFetching={dataPrevYearFetching}
                CAdataPrevYearFetching={CAdataPrevYearFetching}
                showCompareAppTypeStatsArray={showCompareAppTypeStatsArray}
                handleCancelDailyCompareAppType={handleCancelDailyCompareAppType}
                showCompareStats={showCompareStats}
                showCompareStatsForAllAppType={showCompareStatsForAllAppType}
                compareAll={compareAll}
                activePremium={activePremium}
              />
              : (showSpinner
                ? <CommonLoader containerHeight={"300px"} iconFontSize={"50px"} iconColor={"#29394D"} />
                : <EventLineChartLegendFormat
                    updateChartLinesToShow={updateChartLinesToShowFormat}
                    chartLinesToShowFormat={chartLinesToShowFormat}
                    formatData={formatData}
                    formatCAData={formatCAData}
                    fetching={isFormatFetching}
                    isError={isFormatError}
                    type={legendType}
                    showSpinner={showSpinner}
                    seasonsToShow={seasonsToShow}
                    frequency={frequency}
                    period={period}
                  />
              )
          }
        </div>
        <div
          className="event-registrant-line-chart-body-main"
          style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', padding: '20px', gap: '20px' }}
        >
          {
            (showCompareAppTypeStats === false || frequency !== 'DAILY') ?
              legendType === 'TYPE' ?
                error
                  ? <EventLineChartErrorHandler
                      fetchRegistrantLineChartData={fetchRegistrantLineChartDataOnly}
                      fetchRegistrantLineChartCAData={fetchRegistrantLineChartCADataOnly}
                      type={chartType}
                    />
                  : <EventLineChart
                      data={chartType === 'CA'
                        ? (showAccumulateEventStats ? accumulateEventStatsCA : chartDataCA)
                        : (showAccumulateEventStats ? accumulateEventStats : chartData)}
                      chartLinesToShow={chartLinesToShow}
                      fetching={isFetching || accumulateEventStatsFetching || accumulateEventStatsCAFetching}
                      language={language}
                      type={chartType}
                      updateChartType={updateChartType}
                      frequency={frequency}
                      period={period}
                    />
                : error
                  ? <EventLineChartErrorHandler
                      fetchRegistrantLineChartData={fetchRegistrantLineChartDataOnly}
                      fetchRegistrantLineChartCAData={fetchRegistrantLineChartCADataOnly}
                      type={chartType}
                    />
                  : <EventLineChartFormat
                      data={chartType === 'CA' ? formatCAData : formatData}
                      chartLinesToShowSeason={chartLinesToShowSeason}
                      fetching={isFormatFetching}
                      language={language}
                      type={chartType}
                      updateChartType={updateChartType}
                      seasonsToShow={seasonsToShow}
                      frequency={frequency}
                      period={period}
                      showAccumulateEventStats={showAccumulateEventStats}
                      formatAccumulateData={formatAccumulateData}
                      formatAccumulateCAData={formatAccumulateCAData}
                    />
              : null
          }
          {
            legendType === 'TYPE' && showCompareAppTypeStats === true && frequency === 'DAILY'
              ? <CompareStatsChart
                  data1={chartType === 'CA'
                    ? (showAccumulateEventStats ? chartDataCAByLinenamAccumulate : chartDataCAByLinename)
                    : (showAccumulateEventStats ? chartDataByLinenameAccumulate : chartDataByLinename)}
                  data2={chartType === 'CA'
                    ? (showAccumulateEventStats ? chartDataCAByLinenamePrevYearAccumulate : chartDataCAByLinenamePrevYear)
                    : (showAccumulateEventStats ? chartDataByLinenamePrevYearAccumulate : chartDataByLinenamePrevYear)}
                  chartLinesToShow={chartLinesToShow}
                  fetching={isFetching || dataPrevYearFetching || CAdataPrevYearFetching}
                  language={language}
                  year1={eventStatsFilter.year[0]}
                  year2={eventStatsFilter.year[0] - 1}
                  type={chartType}
                  startMonth={'01'}
                  endMonth={'12'}
                  updateType={updateChartType}
                  frequency={frequency}
                />
              : null
          }
        </div>
      </div>

      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "2%" }} className="mt-3">
        <div style={{ display: "flex", alignItems: "center", width: "40%", justifyContent: "space-between" }}>
          <div className={"event-manage-turnover"} style={{ margin: 0 }} onClick={() => handleBudgetManagementModalVisibility(true)}>
            <img src="/img/icons/event-stats/settings.svg" className={'mr-1'} />
            <span>{_("MANAGE_MY_TURNOVER")}</span>
          </div>
          {frequency === "YEARLY" && eventStatsFilter.year.length === 1 &&
            <span style={{ cursor: "pointer" }} onClick={handleGetParticipantsStatsAction}>
              {isDownloadParticipantsStatsLoading && <SyncOutlined spin />}
              {' '}Télécharger les détails des inscriptions
            </span>
          }
        </div>
        <div style={{ width: "60%" }} />
      </div>

      {showCompareStats && (frequency === "MONTHLY" || frequency === "DAILY") &&
        <CompareStats
          chartData1={chartData}
          chartDataCA1={chartDataCA}
          formatData1={formatData}
          formatCAData1={formatCAData}
          languages={languages}
          type={chartType}
          legendType={legendType}
          isFetching={isFetching}
          isError={isError}
          updateChartType={updateChartType}
          updateLegendType={updateLegendType}
          updateChartLinesToShowFormat={updateChartLinesToShowFormat}
          chartLinesToShowFormat={chartLinesToShowFormat}
          chartLinesToShowSeason={chartLinesToShowSeason}
          isFormatFetching={isFormatFetching}
          isFormatError={isFormatError}
          seasonsToShow={seasonsToShow}
          frequency={frequency}
          language={language}
          period={period}
          activePremium={activePremium}
          showCompareStats={showCompareStats}
          showAccumulateEventStats={showAccumulateEventStats}
          accumulateEventStats={accumulateEventStats}
          accumulateEventStatsCA={accumulateEventStatsCA}
          accumulateEventStatsFetching={accumulateEventStatsFetching}
          accumulateEventStatsCAFetching={accumulateEventStatsCAFetching}
          formatAccumulateData={formatAccumulateData}
          formatAccumulateCAData={formatAccumulateCAData}
        />
      }

      {(frequency === "MONTHLY" || frequency === "DAILY") && isFetching === false && chartData.length > 0 && showCompareAppTypeStats === false &&
        <div className={"flex flex-col items-center mt-3"}>
          <span className={"event-cycle-trainings"} onClick={() => handleShowCompareStats(!showCompareStats)}>
            {showCompareStats ? _("REDUCE") : _("COMPARE_WITH_ANOTHER_YEAR")}
          </span>
          <div className={"event-cycle-chevron"} onClick={() => handleShowCompareStats(!showCompareStats)}>
            <img src="/img/icons/chevron-down.svg" className={showCompareStats && "cycle-stats-chevron-rotate"} />
          </div>
        </div>
      }

      {isBudgetManagementModalVisible === true &&
        <BudgetManagementModal handleModalVisibility={handleBudgetManagementModalVisibility} />
      }
    </div>
  );
};

const mapStateToProps = state => ({
  auth: state.auth,
  eventStatsFilter: state.filters.eventStatsFilter,
  language: state.params.lng,
});

const mapDispatchToProps = {
  fetchRegistrantLineChartData,
  fetchRegistrantLineChartCAData,
  getSeasonsValues,
  startCommandGetCANbrInscriptionByFormat,
  getCommandInfo,
  getActivePremium,
  getAccumulateEventStats,
  startCommandCumulateByFormat,
  getParticipantsStatsAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(EventRegistrantLineChart);



// WEBPACK FOOTER //
// ./app/components/Admin/EventStats/EventRegistrantLinechart/EventRegistrantLineChart.js